export default "__VITE_ASSET__DjvFmTC0__"